import { render, staticRenderFns } from "./HeroUtopia.vue?vue&type=template&id=042f0d18"
import script from "./HeroUtopia.vue?vue&type=script&lang=js"
export * from "./HeroUtopia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports